import { Stack, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	title: string;
	icon?: ReactNode;
};

export const SectionHeader: FC<Props> = ({ title, icon }) => (
	<Stack
		direction="row"
		alignItems="center"
		gap={0.8}
		px={1.6}
		pt={2.4}
		pb={0.8}
	>
		{icon}
		<Typography variant="overline" color="text.secondary">
			{title}
		</Typography>
	</Stack>
);
